module.exports = __webpack_public_path__ + "img/Laminet_carton.843ab638.png";